import { Component, OnInit } from '@angular/core';
import { ToasterService, ToastMessage } from "./toaster.service";
import { SfcModule } from "@sfc/angular";


@Component({
    selector: 'app-toaster',
    imports: [
    SfcModule
],
    templateUrl: './toaster.component.html',
    styleUrl: './toaster.component.scss'
})
export class ToasterComponent implements OnInit {
  toastMessage: ToastMessage | null = null;

  constructor(private toasterService: ToasterService) {
  }

  ngOnInit() {
    this.toasterService.toast$.subscribe(message => {
      this.toastMessage = message;
    })
  }

}
